export const KEEP_EXISTING = 'FROM_PUBLISHED';
export const FROM_DRAFT = 'FROM_DRAFT';
export const LEAVE_EMPTY = 'EMPTY';
